import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetBrowseTagsRequest } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/GetBrowseTags.pb'
import { GetBrowseTagsResponse } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/GetBrowseTags.pb'

export const getBrowseTags = (request: GetBrowseTagsRequest, options?: CashRequestOptions) =>
  post<GetBrowseTagsRequest, GetBrowseTagsResponse>('/2.0/cash/get-browse-tags', request, {
    ...options,
    rejectOnError: true,
  })
